export default __webpack_public_path__ + "static/media/bb4.2.0c78b57e.png";